import Image from "next/legacy/image";
import Link from 'next/link';
import { useRef } from 'react';
import getSalaryWithOutBreak from 'wwg-utilities/dist/sharedFunctions/getSalaryWithOutBreak';
import {
  getPublicIDFromURL,
  getResizedImageURL,
} from '../../../lib/cloudinary';
import useCareerConnection from '../../../lib/hooks/careerConnection';
import { useAuth } from '../../../lib/providers/authProvider';
import Heart from '../../icons/Heart';

interface CareerCardProps {
  career: any;
  shouldFadeOnDelete?: boolean;
}

const CareerCard: React.FC<CareerCardProps> = ({
  career,
  shouldFadeOnDelete,
}) => {
  const { seeker } = useAuth();
  const careerRef = useRef<HTMLDivElement>(null);
  const { connection, handleClick } = useCareerConnection(
    career,
    seeker,
    careerRef,
    shouldFadeOnDelete,
  );
  return (
    <section
      ref={careerRef}
      className="relative block cursor-pointer career-card-wrapper"
    >
      <Link href={`/careerguide/${career?.slug}`}>
        <section className="career-card shadow-card rounded-[10px] relative">
          <Image
            src={
              getResizedImageURL(
                getPublicIDFromURL(career?.video?.poster),
                600,
                400,
              ) || ''
            }
            blurDataURL={
              getResizedImageURL(
                getPublicIDFromURL(career?.video?.poster),
                600,
                400,
              ) || ''
            }
            layout="responsive"
            loading="eager"
            placeholder="blur"
            width={600}
            height={400}
            alt=""
            className="h-44 w-full object-cover rounded-tr-[10px] rounded-tl-[10px]"
          />
          <section className="p-4">
            <h2 className="text-lg font-bold leading-6 truncate card-title">
              {career?.title}
            </h2>
            <section className="flex items-center">
              <p className="pr-2 mr-2 text-sm font-bold border-solid text-careerPageHeading border-r-1 border-borderGray">
                {getSalaryWithOutBreak(career?.wageData?.medianAnnualSalary)}
              </p>
              <p className="text-sm font-bold text-careerPageHeading">
                {career?.brightOutlook} Outlook
              </p>
            </section>
          </section>
        </section>
      </Link>
      <section className="absolute top-0 right-0">
        <section className="flex items-center justify-between w-full">
          <Heart
            onClick={handleClick}
            className={` ${
              connection ? 'fill-heart' : ''
            } m-2 h-10 z-20 w-10 stroke-heart cursor-pointer p-2 bg-white rounded-full`}
          />
        </section>
      </section>
    </section>
  );
};

export default CareerCard;
